import { ReportAccessBody } from '../access/ReportAccessDrawer'

/** The drawer's close callback has nothing to close here: the explanation is a tab, not a drawer. */
function stayOnPage() {}

/**
 * Report Detail → Access: the access explanation, exactly as the Report
 * Registry's drawer renders it — `ReportAccessBody` over hooks/useReportAccess.ts,
 * unchanged and not copied, so the two can never disagree about who can reach a
 * report or why.
 *
 * It gates, fetches and fails on its own: RestrictedState on a denied caller
 * (fetching nothing), "No such report" on a 404, and a 500 that names migration
 * AddGrantExpiryAndNotes, which it depends on and which is applied by hand. It
 * fetches only while this tab is mounted, which is only while it is open.
 *
 * The drawer's audit links close the drawer before they navigate; here there is
 * nothing to close, so they simply navigate.
 */
export function AccessTab({ reportId }: { reportId: string }) {
  return <ReportAccessBody reportId={reportId} onClose={stayOnPage} />
}
